import { ContentTypes } from "../brandVariables.types";

export const elgigantenContent: ContentTypes = {
  generalHeadline: "Elgiganten Time Trial",
  generalHeadlineAlt: "Set the fastest time!",
  subHeadline: "Lorem ipsum...",
  overviewHeadline: "Dreamhack winter 2025 winners overview!",
  endscreenHeadline: "Thank you and congratulations!",
};
